module.exports = __webpack_public_path__ + "img/0Q3B7166_WoodMatted.1fd75a1a.jpg";